export var tableAmountCellTheme = {
  baseStyle: _ref => {
    var {
      hasValue,
      additionalAmount
    } = _ref;
    return {
      value: {
        textStyle: 'body3Semi',
        color: hasValue ? 'neutral.black' : 'neutral.darker',
        _disabled: {
          color: 'neutral.light',
          cursor: 'not-allowed'
        }
      },
      additionalAmount: {
        color: additionalAmount !== 0 ? 'neutral.darkest' : 'neutral.darker',
        textStyle: 'body4',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        columnGap: 'xxs',
        _disabled: {
          color: 'neutral.light',
          cursor: 'not-allowed'
        }
      }
    };
  }
};
//# sourceMappingURL=_TableAmountCell.theme.js.map